module.exports = "https://coursera_assets.s3.amazonaws.com/images/5f7e630debb097dbbd53229909406356.svg";